import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import * as XLSX from "xlsx";
import { downloadBlob } from "@/utils/download";

export function useRegistrosTab() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [records, setRecords] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterMember, setFilterMember] = useState("");
  const [startDate, setStartDate] = useState(
    new Date(Date.now() - 30 * 86400000).toISOString().slice(0, 10)
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().slice(0, 10)
  );

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let url = `/timeclock/records?start_date=${startDate}&end_date=${endDate}`;
      if (filterMember && filterMember !== "all") url += `&member_id=${filterMember}`;
      const [rRes, mRes] = await Promise.all([
        authAxiosRef.current.get(url),
        authAxiosRef.current.get("/deliverers/team/members"),
      ]);
      setRecords(rRes.data);
      setMembers(mRes.data.filter((m) => m.invite_accepted));
    } catch {}
    finally { setLoading(false); }
  }, [filterMember, startDate, endDate]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const deleteRecord = async (id) => {
    if (!window.confirm("Eliminar este registro?")) return;
    try {
      await authAxios.delete(`/timeclock/records/${id}`);
      toast.success("Eliminado");
      fetchData();
    } catch { toast.error("Erro ao eliminar"); }
  };

  const editRecord = async (id, form) => {
    try {
      await authAxios.patch(`/timeclock/records/${id}`, form);
      toast.success("Registro corrigido. Auditoria guardada.");
      fetchData();
      return true;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao corrigir registro");
      return false;
    }
  };

  const exportCSV = () => {
    const rows = records.map((r) => ({
      Funcionário: r.member_name,
      Entrada: r.clock_in ? new Date(r.clock_in).toLocaleString("pt-BR") : "",
      Saída: r.clock_out ? new Date(r.clock_out).toLocaleString("pt-BR") : "Em serviço",
      "Horas Trabalhadas": r.hours_worked?.toFixed(2) || "0",
      "Horas Extra": r.overtime_hours?.toFixed(2) || "0",
      Status: r.status === "open" ? "Aberto" : "Fechado",
      Corrigido: r.manually_corrected ? "Sim" : "Não",
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Registros");
    const buf = XLSX.write(wb, { bookType: "csv", type: "array" });
    downloadBlob(
      new Blob([buf], { type: "text/csv;charset=utf-8" }),
      `ponto_registros_${endDate}.csv`
    );
    toast.success("CSV exportado!");
  };

  return {
    records, members, loading,
    filterMember, setFilterMember,
    startDate, setStartDate,
    endDate, setEndDate,
    deleteRecord, editRecord, exportCSV,
  };
}
